
<script setup>
import { Hints, Heading, MultiSelect, Alert, SectionHead } from '@components'

// Settings
import DarkModeStore from '@o/store'
const { options, isLocked } = DarkModeStore()

// Contents
import useContents from '@stores/contents'
const $contents = useContents()

const isWCInstalled = wp_dark_mode_admin_json.wc.is_installed
const isWCActive = wp_dark_mode_admin_json.wc.is_active

</script>

<template>
    <Row transparent gap="6">
        <SectionHead  class="text-lg"> Exclude WooCommerce <template #description>Exclude dark mode on WooCommerce products and categories
            </template>
        </SectionHead>
        <Alert color="orange" v-if="!isWCInstalled || !isWCActive"> WooCommerce is not {{ isWCInstalled ? 'active' :
            'installed' }}. Please {{ isWCInstalled ? 'active' : 'install' }} WooCommerce to use this feature. </Alert>
        <Row class="flex-col sm:flex-row" space :disabled="!isWCInstalled || !isWCActive">
           
            <Heading class="whitespace-nowrap">
                <Row inline center>
                    <Row locked :ProBadge="false"  class="whitespace-nowrap">Exclude WC Products</Row> <ProBadge />
                </Row>
            </Heading>
            <Row class="w-full" locked>
                <MultiSelect :items="$contents.products" v-model="options.excludes_wc_products"
                    placeholder="Enter your selected WooCommerce products" :disabled="options.excludes_wc_products_all" />
                <Hints>Add products to exclude the dark mode from the WooCommerce categories.</Hints>
                <Row inline class="pt-[10px] text-sm"><span class="font-semibold">Exclude All</span>
                    <Toggle v-model="options.excludes_wc_products_all">Except:</Toggle>
                </Row>
                <MultiSelect :items="$contents.products" v-model="options.excludes_wc_products_except"
                    placeholder="Enter WooCommerce products" :disabled="!options.excludes_wc_products_all" />
                <Hints>Dark Mode will only work on the selected WooCommerce products.</Hints>
            </Row>
        </Row>
        <Row class="flex-col sm:flex-row" space :disabled="!isWCInstalled || !isWCActive">
       
            <Heading class="whitespace-nowrap">
                <Row inline center>
                    <Row locked :ProBadge="false"  class="whitespace-nowrap">Exclude WC Categories</Row> <ProBadge />
                </Row>
            </Heading>
            <Row class="w-full" locked>
                <MultiSelect :items="$contents.productCategories" v-model="options.excludes_wc_categories"
                    placeholder="Enter your selected WooCommerce categories"
                    :disabled="options.excludes_wc_categories_all" />
                <Hints>Add categories to exclude the dark mode from the WooCommerce categories.</Hints>
                <Row inline class="pt-[10px] text-sm"><span class="font-semibold">Exclude All</span>
                    <Toggle v-model="options.excludes_wc_categories_all">Except:</Toggle>
                </Row>
                <MultiSelect :items="$contents.productCategories" v-model="options.excludes_wc_categories_except"
                    placeholder="Enter WooCommerce categories" :disabled="!options.excludes_wc_categories_all" />
                <Hints>Dark Mode will only work on the selected WooCommerce categories.</Hints>
            </Row>
        </Row>
    </Row>
</template>
